import { Form, Space, TableProps } from 'antd';
import { EditIcon } from 'assets/svg';
import { ButtonAction } from 'components';
import InputNumberForm from 'components/Input/InputNumberForn';
import TableComponent from 'components/Table/TableComponent';
import { useUser } from 'contexts/UserProvider';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import React, { forwardRef, useImperativeHandle } from 'react';
import { formatDate, generateUUID } from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';
import { HocChangePagination } from 'utils/HocChangePagination';

interface IProps extends React.PropsWithChildren<TableProps> {
  data: any;
  onSave: () => void;
  onCancel: () => void;
  onEdit: (data: any) => void;
  indexHandle: number;
  // setIndexHandle: (value: number) => void;
  // isAdd: boolean;
  form: any;
  refetch: (isExport?: boolean, headerRow?: any) => void;
}
const { SaveTwoTone, CloseCircleTwoTone } = icons;
const TableGrossProfit = forwardRef((props: IProps, ref: any) => {
  const {
    data = {},
    loading,
    refetch,
    onSave,
    onCancel,
    onEdit,
    indexHandle,
    // isAdd,
    form,
  } = props;

  const { user } = useUser();

  const columns: ColumnsTypeCustom = [
    {
      title: 'STT',
      width: 50,
      align: 'center',
      render: (_, __, index) =>
        data.pageInfo?.itemsPerPage * (data.pageInfo?.currentPage - 1) +
        index +
        1,
    },
    {
      title: 'Chi nhánh',
      width: 130,
      dataIndex: 'plantId',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'plantId'} className="m-0">
        //       <SelectForm placeholder="Chọn chi nhánh" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      title: 'Chủng loại',
      width: 130,
      dataIndex: 'type',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'type'} className="m-0">
        //       <SelectForm placeholder="Chọn chủng loại" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      title: 'Tuổi vàng',
      width: 130,
      dataIndex: 'age',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'age'} className="m-0">
        //       <SelectForm placeholder="Chọn tuổi vàng" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    {
      title: 'MRP',
      width: 130,
      dataIndex: 'mrp',
      render: (value, record, index) => {
        // if (indexHandle === index)
        //   return (
        //     <Form.Item name={'mrp'} className="m-0">
        //       <SelectForm placeholder="Chọn MRP" size="middle" />
        //     </Form.Item>
        //   );
        return value;
      },
    },
    // {
    //   title: 'Doanh thu công',
    //   width: 130,
    //   dataIndex: 'processPrice',
    //   render(value, record, index) {
    //     // if (indexHandle === index)
    //     //   return (
    //     //     <Form.Item name={'processPrice'} className="m-0">
    //     //       <SelectForm placeholder="Chọn doanh thu công" size="middle" />
    //     //     </Form.Item>
    //     //   );
    //     return value;
    //   },
    // },
    {
      title: 'TSLN (%)',
      width: 130,
      dataIndex: 'percentProfit',
      align: 'right',
      render(value, record, index) {
        if (indexHandle === index)
          return (
            <Form.Item name={'percentProfit'} className="m-0">
              <InputNumberForm
                placeholder="Nhập TSLN"
                size="middle"
                min={0}
                max={100}
                precision={0}
              />
            </Form.Item>
          );
        return value;
      },
    },
    // {
    //   title: 'Lãi gộp',
    //   width: 130,
    //   dataIndex: 'compoundInterest',
    //   render(value, record, index) {
    //     // if (indexHandle === index)
    //     //   return (
    //     //     <Form.Item name={'compoundInterest'} className="m-0">
    //     //       <SelectForm placeholder="Chọn lãi gộp" size="middle" />
    //     //     </Form.Item>
    //     //   );
    //     return value;
    //   },
    // },
    // {
    //   title: 'Tiền tệ',
    //   width: 130,
    //   dataIndex: 'moneyId',
    //   render() {
    //     // if (indexHandle === index)
    //     //   return (
    //     //     <Form.Item name={'moneyId'} className="m-0">
    //     //       <SelectForm placeholder="Chọn tiền tệ" size="middle" />
    //     //     </Form.Item>
    //     //   );
    //     return 'VNĐ';
    //   },
    // },
    {
      title: 'Người khai báo',
      width: 130,
      dataIndex: ['tcreateUser', 'fullName'],
    },
    {
      title: 'Ngày khai báo',
      width: 170,
      dataIndex: 'createDate',
      render: (text) => formatDate(text),
    },
    {
      title: 'Người cập nhật',
      width: 130,
      dataIndex: ['tmodifyUser', 'fullName'],
    },
    {
      title: 'Ngày cập nhật',
      width: 170,
      dataIndex: 'modifyDate',
      render: (text) => formatDate(text),
    },
    {
      fixed: 'right',
      align: 'center',
      width: 70,
      render: (__, record, index) =>
        index === indexHandle ? (
          <Space size={'middle'} className="text-lg">
            <ButtonAction tooltip="Lưu" onClick={onSave}>
              <SaveTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
            <ButtonAction tooltip="Hủy" onClick={onCancel}>
              <CloseCircleTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
          </Space>
        ) : (
          <Space size={'middle'} className="text-lg ">
            <ButtonAction
              tooltip="Chỉnh sửa"
              onClick={() => onEdit(index)}
              disabled={!(user?.isAdmin || user?.isHO || user?.isNS)}
            >
              <EditIcon />
            </ButtonAction>
          </Space>
        ),
    },
  ];

  useImperativeHandle(ref, () => ({
    exportExcel,
  }));

  const exportExcel = () => {
    refetch(true, columns);
  };

  return (
    <Content>
      <Form form={form}>
        <TableComponent
          scroll={{ x: 'max-content' }}
          columns={columns}
          // dataSource={[{}]}
          dataSource={data.items}
          rowKey={(record: any) => record?.id || generateUUID()}
          loading={loading}
          pagination={{
            disabled:
              // isAdd ||
              indexHandle !== -1,
            current: data.pageInfo?.currentPage,
            pageSize: data.pageInfo?.itemsPerPage,
            total: data.pageInfo?.totalItems,
            onChange: HocChangePagination(),
          }}
        />
      </Form>
    </Content>
  );
});

export default TableGrossProfit;
